import type { IconData } from '@stacksjs/iconify-core'

export const bw1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#00cbff\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M0 192h512v128H0z\"/><path fill=\"#000001\" d=\"M0 212.7h512V299H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bw1x1
